import { Box, Divider, Radio, RadioGroup, Typography } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import { useEffect, useState } from "react";

const ChildComp = ({ name, desc, price, value }) => {
  return (
    <>
      <Box
        width="100%"
        display="flex"
        flexDirection="row"
        alignItems="center"
        justifyContent="space-between"
        gap={1}
        my={1}
      >
        <Radio flex={0.1} value={value} />

        <>
          {desc ? (
            <Box flex={3} maxWidth="60%" textOverflow="clip">
              <Typography fontSize=".8em">{name}</Typography>
              <Typography fontSize=".75em">{desc}</Typography>
            </Box>
          ) : (
            <Box
              flex={3}
              display="flex"
              flexDirection="column"
              maxWidth="54%"
              textOverflow="clip"
              alignItems="flex-start"
              justifyContent="center"
            >
              <Typography fontSize=".9em">{name}</Typography>
            </Box>
          )}
        </>

        <Typography 
          flex={1} 
          textAlign="right"
          fontSize=".9em"
        >
          {price
            ? `+ ${new Intl.NumberFormat("id-ID", {
                style: "currency",
                currency: "IDR",
                minimumFractionDigits: 0,
              }).format(price)}`
            : null}
        </Typography>
      </Box>
      <Divider />
    </>
  );
};

const CheckBoxComp = ({ name, desc, price, value, onChange }) => {
  return (
    <>
      <Box
        width="100%"
        display="flex"
        flexDirection="row"
        alignItems="center"
        justifyContent="space-between"
        gap={1}
        my={1}
      >
        <Checkbox flex={0.1} checked={value} onChange={onChange} />

        <>
          {desc ? (
            <Box flex={3} maxWidth="60%" textOverflow="clip">
              <Typography fontSize=".8em">{name}</Typography>
              <Typography fontSize=".75em">{desc}</Typography>
            </Box>
          ) : (
            <Box
              flex={3}
              display="flex"
              flexDirection="column"
              maxWidth="54%"
              textOverflow="clip"
              alignItems="flex-start"
              justifyContent="center"
            >
              <Typography fontSize=".9em">{name}</Typography>
            </Box>
          )}
        </>

        <Typography 
          flex={1} 
          textAlign="right"
          fontSize=".9em"
        >
          {price
            ? `+ ${new Intl.NumberFormat("id-ID", {
                style: "currency",
                currency: "IDR",
                minimumFractionDigits: 0,
              }).format(price)}`
            : null}
        </Typography>
      </Box>
      <Divider />
    </>
  );
};

const VarianComponent = ({ max_var, add_func, list }) => {
  const [selectedVar, setSelectedVar] = useState([]);
  const [selectedBox, setSelectedBox] = useState([]);

  // ===== Single select =====
  // const changeVar = (e) => {
  //   setSelectedVar(e.target.value);
    
  //   let val = e.target.value;

  //   let filter = list.filter((ele) => {
  //     return ele.varian_id === val;
  //   });

  //   tempStore(filter[0]);
  //   add_func(true);
  // };

  const changeVar = (e) => {
    const val = e.target.value;

    if (selectedVar === val) {      
      setSelectedVar("");
      
      let arr = JSON.parse(localStorage.getItem("varian_data")) || [];
      let tArr = arr.filter((ele) => ele.varian_id !== val);
      localStorage.setItem("varian_data", JSON.stringify(tArr));
      
      add_func(false);
      return;
    }
    
    setSelectedVar(val);

    let filter = list.filter((ele) => ele.varian_id === val);
    tempStore(filter[0]);
    add_func(true);
  };

  // ===== Multi select =====
  const handleChangeBox = (value) => {
    setSelectedBox((prev) =>
      prev.includes(value) ? prev.filter((v) => v !== value) : [...prev, value]
    );
  };

  // ===== Util: simpan radio ke localStorage =====
  
  const tempStore = (varianData) => {
    let arr = JSON.parse(localStorage.getItem("varian_data")) || [];    

    let filter = arr.filter((ele) => {
      return ele.type === varianData.type;
    });

    if (filter.length < 1) {
      let tArr = arr;
      tArr.push(varianData);

      localStorage.setItem("varian_data", JSON.stringify(tArr));
    } else {
      let tArr = arr.filter((ele) => {
        return ele.type !== varianData.type;
      });
      tArr.push(varianData);

      localStorage.setItem("varian_data", JSON.stringify(tArr));
    }    
  }; 

  useEffect(() => {
    let vd = localStorage.getItem("varian_data");
    let varianData = JSON.parse(vd) || [];

    let selectedArr = [];
    if (selectedBox.length > 0) {
      selectedBox.forEach((s) => {
        let selectedObj = list.filter((ele) => {
          return ele.varian_id === s;
        });
        selectedArr.push(selectedObj[0]);
      });

      let tArr = varianData.filter((ele) => {
        return ele.type !== selectedArr[0]?.type;
      });
      tArr.push(...selectedArr);
      
      localStorage.setItem("varian_data", JSON.stringify(tArr));
    } else {
      let tArr = varianData.filter((ele) => {
        return (
          ele.addon_type != "extra_saus" && ele.addon_type != "extra_sambal"
        );
      });
      localStorage.setItem("varian_data", JSON.stringify(tArr));
    }
    // Inform get addon function
    add_func(true);
  }, [selectedBox]);

  return (
    <Box>
      {max_var < 2 ? (
        <RadioGroup value={selectedVar} onChange={changeVar}>
          {list.map((ele) => (
            <ChildComp
              key={ele.varian_id}
              name={ele.name}
              desc={ele.desc}
              price={ele.varian_price}
              value={ele.varian_id}
            />
          ))}
        </RadioGroup>
      ) : (
        <>
          {list.map((ele) => (
            <CheckBoxComp
              key={ele.varian_id}
              name={ele.name}
              desc={ele.desc}
              price={ele.varian_price}
              value={selectedBox.includes(ele.varian_id)}
              onChange={() => handleChangeBox(ele.varian_id)}
            />
          ))}
        </>
      )}
    </Box>
  );
};

export default VarianComponent;